module.exports = __webpack_public_path__ + "img/icon_church_white.20845c46.svg";